<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
      Network: "Rede",
      Team: "Equipe",
      Username: "Usuário",
      Name: "Nome",
      Date: "Data",
      Level: "Nível",
      Plan: "Plano",
      Status: "Status",
      Qualified: "Qualificado",
      Unqualified: "Não Qualificado",
      Left: "Esquerdo",
      Right: "Direito",
      Pending: "Pendente",
      Approved: "Aprovado",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.",
      "No records found.": "Nenhum registro encontrado.",
      Graduation: "Graduação",
      Binary: "Binário",
      "Total Team": "Total da Equipe",
      ACTIVE: "ATIVO",
      INACTIVE: "INATIVO",
      Country: "País",
      All: "Todos",
      "Left side": "Lado Esquerdo",
      "Right side": "Lado Direito",
      "minimum 3 characters": "mínimo 3 caracteres",
    },
    es: {
      Network: "Red",
      Team: "Equipo",
      Username: "Nombre de Usuario",
      Name: "Nombre",
      Date: "Fecha",
      Level: "Nivel",
      Plan: "Plan",
      Status: "Estado",
      Qualified: "Calificado",
      Unqualified: "No Cualificado",
      Left: "Izquierdo",
      Right: "Derecho",
      Pending: "Pendiente",
      Approved: "Aprobado",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtalo de nuevo más tarde.",
      "No records found.": "No se encontraron registros.",
      Graduation: "Graduación",
      Binary: "Binario",
      "Total Team": "Total del Equipo",
      ACTIVE: "ACTIVO",
      INACTIVE: "INACTIVO",
      Country: "País",
      All: "Todos",
      "Left side": "Lado Izquierdo",
      "Right side": "Lado Derecho",
      "minimum 3 characters": "mínimo 3 caracteres",
    },
  },
  components: {
    Layout,
    Stat,
  },
  data() {
    return {
      page: 1,
      pages: 0,
      table: {
        body: null,
      },

      filters: {
        country: "",
        username: "",
        name: "",
        level: "",
        plan: "",
        graduation: "",
        monthly: "",
        binary: "",
      },
      options: {
        countries: [],
        levels: [],
        plans: [],
        graduations: [],
      },
      searchTimer: null,

      statData: null,
    };
  },
  computed: {
    // Mes de referencia da mensalidade, que a API sempre calcula no mes atual
    currentMonth() {
      return this.$moment().format('MM/YYYY')
    },
    // Colunas da tabela. Computed para os rotulos acompanharem o idioma
    fields() {
      return [
        { key: "country", label: "" },
        // notranslate evita que o tradutor do navegador altere esses valores
        { key: "username", label: this.t("Username"), tdClass: "notranslate" },
        { key: "date", label: this.t("Date"), tdClass: "notranslate" },
        { key: "level", label: this.t("Level"), tdClass: "notranslate" },
        { key: "package", label: this.t("Plan") },
        { key: "graduation", label: this.t("Graduation") },
        { key: "monthly", label: this.t("Status") },
        { key: "binary", label: this.t("Binary") },
      ];
    },
    // Rotulo do que esta selecionado em cada dropdown
    selected() {
      const country = this.options.countries.find(
        (item) => item.abbr === this.filters.country
      );
      const plan = this.options.plans.find(
        (item) => item.id === this.filters.plan
      );
      const graduation = this.options.graduations.find(
        (item) => item.id === this.filters.graduation
      );
      const status = {
        active: this.t("ACTIVE"),
        inactive: this.t("INACTIVE"),
      };
      const sides = {
        l: this.t("Left side"),
        r: this.t("Right side"),
      };

      return {
        country: country ? country.name : this.t("All"),
        username: this.filters.username
          ? this.filters.username.toUpperCase()
          : this.t("All"),
        name: this.filters.name ? this.filters.name : this.t("All"),
        level: this.filters.level
          ? this.t("Level") + " " + this.filters.level
          : this.t("All"),
        plan: plan ? plan.name : this.t("All"),
        graduation: graduation ? graduation.name : this.t("All"),
        monthly: status[this.filters.monthly] || this.t("All"),
        binary: sides[this.filters.binary] || this.t("All"),
      };
    },
  },
  methods: {
    // Os campos de texto so filtram a partir de 3 caracteres
    getTextQuery(value) {
      return value && value.trim().length >= 3 ? value.trim() : "";
    },
    getTeam() {
      this.table.body = null;

      const params = new URLSearchParams();
      params.append("page", this.page);

      const query = {
        country: this.filters.country,
        username: this.getTextQuery(this.filters.username),
        name: this.getTextQuery(this.filters.name),
        level: this.filters.level,
        plan: this.filters.plan,
        graduation: this.filters.graduation,
        monthly: this.filters.monthly,
        binary: this.filters.binary,
      };

      Object.keys(query).forEach((key) => {
        if (query[key] !== "" && query[key] !== null) {
          params.append(key, query[key]);
        }
      });

      api
        .get("network/team?" + params.toString())
        .then((response) => {
          if (response.data.status == "success") {
            this.table.body = response.data.list;
            this.statData = [
              {
                type: "line",
                icon: "bx bx-user-plus",
                title: "Total Team",
                value: response.data.total,
              },
            ];
            this.pages = response.data.pages;

            if (response.data.filters) {
              this.options.countries = response.data.filters.countries || [];
              this.options.levels = response.data.filters.levels || [];
              this.options.plans = response.data.filters.plans || [];
              this.options.graduations = response.data.filters.graduations || [];
            }
          }
        })
        .catch(() => {
          this.table.body = [];
        })
    },
    // Ao trocar um filtro volta para a primeira pagina;
    // quando a pagina muda, o watch de page ja recarrega a lista
    applyFilters() {
      if (this.page === 1) {
        this.getTeam();
      } else {
        this.page = 1;
      }
    },
    // Campos de texto so disparam depois que o usuario para de digitar
    applyFiltersDebounced() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.applyFilters();
      }, 500);
    },
  },
  mounted() {
    this.getTeam();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  watch: {
    page: function () {
      this.getTeam();
    },
    "filters.country": function () {
      this.applyFilters();
    },
    "filters.level": function () {
      this.applyFilters();
    },
    "filters.plan": function () {
      this.applyFilters();
    },
    "filters.graduation": function () {
      this.applyFilters();
    },
    "filters.monthly": function () {
      this.applyFilters();
    },
    "filters.binary": function () {
      this.applyFilters();
    },
    // Ignora digitacao que continua abaixo do minimo de 3 caracteres
    "filters.username": function (value, old) {
      if (this.getTextQuery(value) !== this.getTextQuery(old)) {
        this.applyFiltersDebounced();
      }
    },
    "filters.name": function (value, old) {
      if (this.getTextQuery(value) !== this.getTextQuery(old)) {
        this.applyFiltersDebounced();
      }
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">{{ t('Network') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Team') }}</h3>
        <p></p>
      </div>
    </div>

    <div id="dropdown" class="d-flex flex-wrap mb-4 filters-grid">
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Country') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.country }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.country" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="country in options.countries" :key="country.abbr">
          <b-form-radio v-model="filters.country" :value="country.abbr">{{ country.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Username') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.username }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form @submit.prevent>
          <b-form-input v-model="filters.username" autocomplete="off"></b-form-input>
          <small class="text-muted">{{ t('minimum 3 characters') }}</small>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Name') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.name }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form @submit.prevent>
          <b-form-input v-model="filters.name" autocomplete="off"></b-form-input>
          <small class="text-muted">{{ t('minimum 3 characters') }}</small>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Level') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.level }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.level" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="level in options.levels" :key="level">
          <b-form-radio v-model="filters.level" :value="level">Nível {{ level }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Plan') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.plan }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.plan" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="plan in options.plans" :key="plan.id">
          <b-form-radio v-model="filters.plan" :value="plan.id">{{ plan.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Graduation') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.graduation }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.graduation" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="graduation in options.graduations" :key="graduation.id">
          <b-form-radio v-model="filters.graduation" :value="graduation.id">{{ graduation.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Status') }}</h6>
              <div class="font-size-12 text-muted text-capitalize">{{ selected.monthly.toLowerCase() }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.monthly" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form>
          <b-form-radio v-model="filters.monthly" value="active" class="text-capitalize">{{ t('ACTIVE').toLowerCase() }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form>
          <b-form-radio v-model="filters.monthly" value="inactive" class="text-capitalize">{{ t('INACTIVE').toLowerCase() }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Binary') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.binary }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.binary" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form>
          <b-form-radio v-model="filters.binary" value="l">{{ t('Left side') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form>
          <b-form-radio v-model="filters.binary" value="r">{{ t('Right side') }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div v-if="!table.body" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="table.body && table.body.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          {{ t('No records found.') }}
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <b-table :items="table.body" :fields="fields" class="table-nowrap table-style table-hover" head-variant="light" responsive>
            <template #cell(country)="row">
              <img v-if="row.value" :src="'https://kapowaz.github.io/circle-flags/flags/' + row.value + '.svg'" :alt="row.value.toUpperCase()" :title="row.value.toUpperCase()" width="24" />
            </template>
            <template #cell(username)="row">
              <span class="font-size-12">{{ row.value }}</span><br>
              {{ row.item.name }}
            </template>
            <template #cell(package)="row">
              <span class="badge badge-soft-dark font-size-12">{{ row.value }}</span>
            </template>
            <!-- head(<key>) permite marcacao no cabecalho, que o `label` nao aceita -->
            <template #head(monthly)="column">
              {{ column.label }} <sup class="text-muted">{{ currentMonth }}</sup>
            </template>
            <template #cell(monthly)="row">
              <span v-if="row.value === 'inactive'" class="badge badge-soft-danger font-size-12">{{ t('INACTIVE') }}</span>
              <span v-else-if="row.value === 'active'" class="badge badge-soft-success font-size-12">{{ t('ACTIVE') }}</span>
            </template>
            <template #cell(graduation)="row">
              <span class="badge font-size-12">{{ row.value.name }}</span>
            </template>
            <template #cell(binary)="row">
              <span v-if="row.value.side === 'l'" class="font-size-12">{{ t('Left') }}</span>
              <span v-else-if="row.value.side === 'r'" class="font-size-12">{{ t('Right') }}</span>
              –
              <span v-if="row.value.status === 'inactive'" class="badge badge-soft-warning font-size-12">{{ t('INACTIVE') }}</span>
              <span v-else-if="row.value.status === 'active'" class="badge badge-soft-success font-size-12">{{ t('ACTIVE') }}</span>
            </template>
          </b-table>
        </div>
        <paginate v-if="table.body && table.body.length > 0" v-model="page" :page-count="pages" :page-range="3" :margin-pages="2" prev-text="<i class='mdi mdi-chevron-left'></i>"
          next-text="<i class='mdi mdi-chevron-right'></i>" :container-class="'pagination pagination-rounded justify-content-center mt-4'" :page-class="'page-item'" :page-link-class="'page-link'"
          :prev-link-class="'page-link'" :next-link-class="'page-link'" :break-view-link-class="'page-link'">
        </paginate>
      </div>
    </div>
  </Layout>
</template>

<style>
/* Barra de filtros. Sem `scoped` porque o .dropdown-toggle vem do b-dropdown,
   que nao recebe o atributo de escopo desta pagina.
   O gap de 10px vem do #dropdown global e entra nos calc() abaixo. */
#dropdown.filters-grid {
  flex-wrap: wrap;
  /* O pai (.d-lg-flex, junto do card de total) e flex: sem crescer aqui,
     a barra encolhe ao conteudo e os filtros nao tem espaco para esticar */
  flex: 1 1 auto;
  min-width: 0;
}

/* Desktop: os filtros dividem a linha inteira em partes iguais */
#dropdown.filters-grid > .b-dropdown {
  flex: 1 1 0;
  min-width: 0;
}

#dropdown.filters-grid .dropdown-toggle {
  width: 100%;
}

/* O conteudo do botao precisa ocupar a largura toda para o chevron
   encostar na direita */
#dropdown.filters-grid .dropdown-toggle > div {
  width: 100%;
}

/* Com os botoes estreitos, o valor selecionado nao pode empurrar o chevron */
#dropdown.filters-grid .dropdown-toggle .text-left {
  min-width: 0;
}

#dropdown.filters-grid .dropdown-toggle .text-left > * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Tablet: ate 4 por linha (3 gaps de 10px divididos entre as 4 colunas) */
@media (max-width: 1025px) {
  #dropdown.filters-grid > .b-dropdown {
    flex: 0 0 calc(25% - 7.5px);
  }
}

/* Mobile: 2 por linha. O #dropdown global empilha um por linha aqui,
   por isso a direcao volta para row */
@media (max-width: 576px) {
  #dropdown.filters-grid {
    flex-direction: row;
  }

  #dropdown.filters-grid > .b-dropdown {
    flex: 0 0 calc(50% - 5px);
  }

  #dropdown.filters-grid .dropdown-toggle {
    padding-left: 14px;
  }

  #dropdown.filters-grid .dropdown-menu {
    min-width: 100%;
  }
}
</style>
